// Shop: outfits and decor for gems.

import { h, clear } from '@kit/dom';
import { ITEMS, type Item } from '@avatar/model';
import { avatarEl } from '@avatar/render';
import { DECOR, type Decor } from '../decor';
import { getSave, update, subscribe, owns } from '../state';
import { topBar, toast, banner } from '../ui';
import { drawArtContain } from '@kit/assets';
import { go } from '../router';
import { play as sound } from '@kit/audio';

export function shopScreen(root: HTMLElement) {
  let tab = sessionStorage.getItem('shop.tab') || 'outfits';
  const bar = topBar('Shop', { back: 'hub' });
  const tabs = h('div.tabs');
  const grid = h('div.grid2', { style: { padding: '0 16px 24px' } });
  root.append(bar);
  const ban = banner('scene.shop'); if (ban) root.append(ban);
  root.append(tabs, grid);

  function renderTabs() {
    clear(tabs);
    for (const [id, label] of [['outfits', 'Outfits'], ['decor', 'For the house']]) {
      tabs.append(h('button.tab' + (tab === id ? '.on' : ''), { onclick: () => { tab = id; sessionStorage.setItem('shop.tab', id); renderTabs(); render(); } }, label));
    }
  }

  function buy(id: string, price: number, name: string) {
    const s = getSave();
    if (s.gems < price) { toast(`You need ${price - s.gems} more gems.`); return; }
    update(x => { x.gems -= price; x.totals.gemsSpent += price; if (!x.owned.includes(id)) x.owned.push(id); });
    sound('chime');
    toast(`You got the ${name}!`);
  }

  function itemCard(it: Item): HTMLElement {
    const s = getSave();
    const owned = owns(it.id, s);
    const preview = { ...s.avatar, [it.slot]: it.id } as any;
    const pic = avatarEl(preview, 90);
    const wearing = (s.avatar as any)[it.slot] === it.id;
    return h('div.card.center', null,
      pic,
      h('h3', { style: { fontSize: '15px' } }, it.name),
      owned
        ? h('button.btn.small.block' + (wearing ? '' : '.primary'), {
          disabled: wearing,
          onclick: () => { update(x => { (x.avatar as any)[it.slot] = it.id; }); toast(`Wearing the ${it.name}.`); },
        }, wearing ? 'Wearing' : 'Wear')
        : h('button.btn.small.block' + (s.gems >= it.price ? '.primary' : ''), { onclick: () => buy(it.id, it.price, it.name) }, `${it.price} `, h('span.dot.gem', { style: { display: 'inline-block' } })),
    );
  }

  function decorCard(d: Decor): HTMLElement {
    const s = getSave();
    const owned = owns(d.id, s);
    const cv = document.createElement('canvas');
    const dpr = window.devicePixelRatio || 1;
    const W = 120, H = 90;
    cv.width = W * dpr; cv.height = H * dpr; cv.style.width = W + 'px'; cv.style.height = H + 'px';
    const c = cv.getContext('2d')!; c.setTransform(dpr, 0, 0, dpr, 0, 0);
    c.fillStyle = '#efe9db'; c.fillRect(0, 0, W, H);
    const tile = Math.min(W / Math.max(d.w, 2), H / Math.max(d.h, 2)) * 0.9;
    const dw = d.w * tile, dh = d.h * tile;
    if (!drawArtContain(c, d.id, 4, 4, W - 8, H - 8, 1.2)) d.draw(c, (W - dw) / 2, (H - dh) / 2, dw, dh);
    return h('div.card.center', null,
      cv,
      h('h3', { style: { fontSize: '15px' } }, d.name),
      owned
        ? h('button.btn.small.block', { onclick: () => go('house') }, 'Place it')
        : h('button.btn.small.block' + (s.gems >= d.price ? '.primary' : ''), { onclick: () => buy(d.id, d.price, d.name) }, `${d.price} `, h('span.dot.gem', { style: { display: 'inline-block' } })),
    );
  }

  function render() {
    clear(grid);
    if (tab === 'outfits') {
      const sorted = ITEMS.filter(i => i.price > 0).sort((a, b) => a.price - b.price);
      for (const it of sorted) grid.append(itemCard(it));
    } else {
      for (const d of DECOR.filter(x => !x.exclusive).sort((a, b) => a.price - b.price)) grid.append(decorCard(d));
    }
  }

  renderTabs(); render();
  const un = subscribe(render);
  return () => un();
}
